module.exports = __webpack_public_path__ + "img/wfh.525e987b.png";